import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
var _excluded = ["subColor"];
import React, { memo } from 'react';
import { SVGUniqueID } from '@ali/we-icons-utils';
export var Lightbulbfull20 = /*#__PURE__*/memo(_ref => {
  var {
      subColor = "#FFCE20"
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/React.createElement(SVGUniqueID, null, /*#__PURE__*/React.createElement("svg", _extends({
    width: typeof props.size === 'number' ? props.size : 20,
    height: typeof props.size === 'number' ? props.size : 20,
    fill: "none",
    viewBox: "0 0 20 20",
    className: "_lightbulbfull20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: subColor,
    d: "M12.507 18H7.493A.498.498 0 0 1 7 17.496c0-.268.217-.496.493-.496h5.014c.276 0 .493.228.493.504a.496.496 0 0 1-.493.496M7.004 15.564v-.001l-.001-.009a4.414 4.414 0 0 0-.204-.775c-.167-.454-.436-.944-.85-1.254a6.75 6.75 0 1 1 8.102 0l-.007.005-.005.004-.005.003-.009.007-.02.015a3.008 3.008 0 0 0-.484.496c-.27.35-.521.84-.521 1.445v.5H7.06l-.056-.436ZM10 3.5a.5.5 0 0 0-.062.996c1.495.187 2.535.83 3.12 1.927.295.551.442 1.077.442 1.577a.5.5 0 0 0 1 0c0-.667-.186-1.35-.559-2.048-.748-1.402-2.04-2.218-3.879-2.448A.5.5 0 0 0 10 3.5Z"
  })));
});